export default __webpack_public_path__ + "static/media/marble.e309860a.png";